import React from "react";
import "./Guages.css";

function Guages() {
  return <div className="guageContainer"></div>;
}

export default Guages;
